import moment from 'moment';

export const MonthPickerOptions = {
  shortcuts: [
    {
      text: '当日',
      onClick(picker) {
        picker.$emit('pick', [
          moment().format('YYYY-MM-DD 00:00:00'),
          moment().format('YYYY-MM-DD 23:59:59'),
        ]);
      },
    },
    {
      text: '最近一周',
      onClick(picker) {
        picker.$emit('pick', [
          moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'),
          moment().format('YYYY-MM-DD 23:59:59'),
        ]);
      },
    },
    {
      text: '最近一个月',
      onClick(picker) {
        picker.$emit('pick', [
          moment().subtract(30, 'days').format('YYYY-MM-DD 00:00:00'),
          moment().format('YYYY-MM-DD 23:59:59'),
        ]);
      },
    },
    // {
    //   text: '最近三个月',
    //   onClick(picker) {
    //     picker.$emit('pick', [
    //       moment().subtract(90, 'days').format('YYYY-MM-DD 00:00:00'),
    //       moment().format('YYYY-MM-DD 23:59:59'),
    //     ]);
    //   },
    // },
  ],
};
